export const KEY_CODES = {
    DELETE: "Delete",
    ENTER: "Enter",
    S: "KeyS",
    ESCAPE: "Escape",
} as const;